import React from 'react';

import { UseFormReturn } from 'react-hook-form';

import { Company } from '_lib/api/apiTypes.shim';

import { WarningAlert } from '_lib/components/Alert/Alert';
import { Typography } from '_lib/components/Typography/Typography';
import { AuthUser } from '_lib/featureComponents/auth/auth.types';

import {
  CompanyContactsForm,
  CompanyContactsFormValues,
  companyContactsFormValues
} from '../../CompanyFormItems/CompanyContactsForm/CompanyContactsForm';
import { FormWrapper } from '../../CompanyFormItems/FormWrapper/FormWrapper';

import { TabChangeObj } from '../CompanyUpdate';

import { useCompanyUpdateForm } from './hooks/useCompanyUpdateForm';

export type CompanyContactsProps = {
  company: Company;
  authUser: AuthUser;
  tabChangeObj: TabChangeObj;
};

export const CompanyContacts = (props: CompanyContactsProps) => {
  const { company, authUser, tabChangeObj } = props;

  const { companyUpdateFormContext, validationErrors, allErrors, handleSave, isPending } = useCompanyUpdateForm({
    company,
    authUser,
    formValuePaths: companyContactsFormValues,
    tabChangeObj,
    snackMessage: 'Company contacts saved'
  });

  return (
    <FormWrapper
      isFetchingOrPending={isPending}
      formValues={companyUpdateFormContext.getValues()}
      onSave={handleSave}
      validationErrors={validationErrors}
      allErrors={allErrors}
      disabled={!company?.isActive}>
      {company.isZoned && (
        <WarningAlert>
          <Typography text='Contact information can be overwritten by individual zones.' />
        </WarningAlert>
      )}
      <CompanyContactsForm
        companyContactsFormContext={companyUpdateFormContext as unknown as UseFormReturn<CompanyContactsFormValues>}
        company={company}
      />
    </FormWrapper>
  );
};
